import { CreateOrderRequest } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

const MIN_QUANTITY = 1;
const MAX_QUANTITY = 1000000000;

export interface UpdateItemQuantityPayload {
    itemId: string;
    amount: number;
    cartItemId: string;
}

export const updateItemQuantity = (state: WritableDraft<CreateOrderRequest>, action: PayloadAction<UpdateItemQuantityPayload>) => {
    const { cartItemId, itemId, amount } = action.payload;
    const { orderLines } = state;
    const itemIndex = orderLines
        .findIndex((it) => it.cartItemId === cartItemId && it.shopItemId === itemId);
    if (itemIndex === -1) {
        return;
    }
    const item = orderLines[itemIndex];
    const newQuantity = item.quantity + amount;

    if (newQuantity < MIN_QUANTITY || newQuantity > MAX_QUANTITY) {
        return;
    }
    state.orderLines[itemIndex].quantity = newQuantity;
};

export function removeItemByCartItemId(
    state: WritableDraft<CreateOrderRequest>,
    payload: PayloadAction<string>,
) {
    state.orderLines = state.orderLines.filter((item) => item.cartItemId !== payload.payload);
}
